/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";

const ServiceSection = () => {
  const [selectedService, setSelectedService] = useState("Core Service Lines");

  const services = {
    "Core Service Lines": {
      title: "Core Service Lines",
      description:
        "Katella Venture Capital LLC is a multi-service business firm committed macroeconomic to supporting entrepreneurs, investors, and small businesses with practical, growth-focused solutions.",
      servicesList: [
        "Capital Investment",
        "Real Estate Investment",
        "Zero Reporting Services",
        "Tax Accounting",
        "Construction Modelling",
        "Payroll Services",
      ],
      image: "../assets/images/service1.jpg",
      color: "bg-gradient-to-r from-blue-400 to-blue-600", // Blue gradient
    },
    "Technology Infrastructure": {
      title: "Technology Infrastructure",
      description:
        "All Katella Venture Capital services are supported by customized enterprise technology tools built by Flynn Holding Digital LLC, including:",
      servicesList: [
        "Digital venture fund dashboard (for partners and LPs)",
        "Real estate analytics & portfolio tracker",
        "Automated tax and zero-reporting platform",
        "Construction modeling & rendering toolkits",
        "Secure client portals for payroll and accounting",
      ],
      image: "./assets/images/service2.jpg",
      color: "bg-gradient-to-r from-green-400 to-green-600", // Green gradient
    },
    "Target Market Segments": {
      title: "Target Market Segments",
      description:
        "Our solutions are tailored for clients seeking expert support in venture funding, financial compliance, property investment, and business infrastructure, especially those in growth or transition phases.",
      servicesList: [
        "Real Estate Developers",
        "Startups & Founders",
        "SMEs & Corporates",
        "International Firms",
      ],
      image: "./assets/images/service3.jpg",
      color: "bg-gradient-to-r from-purple-400 to-purple-600", // Purple gradient
    },
    "Competitive Advantages": {
      title: "Competitive Advantages",
      description:
        "With flexible service options and a focus on long-term value, we offer clients a strategic edge in today’s competitive business landscape.",
      servicesList: [
        "Portfolio",
        "Presence",
        "Texas",
        "Scalability",
        "Compliance",
        "Driven",
      ],
      image: "./assets/images/service4.jpg",
      color: "bg-gradient-to-r from-orange-400 to-orange-600", // Orange gradient
    },
    "Business Structure": {
      title: "Business Structure",
      description:
        "Katella Venture Capital LLC operates through a structured framework of specialized service divisions, each led by experienced professionals in their respective fields.",
      servicesList: [
        "Managing Partners",
        "Venture Analysts",
        "Tax Professionals & CPAs",
        "Real Estate & Construction Teams",
        "Payroll & HR Compliance Officers",
        "Technology Liaison Unit",
      ],
      image: "./assets/images/service5.jpg",
      color: "bg-gradient-to-r from-teal-400 to-teal-600", // Teal gradient
    },
    "Marketing & Client": {
      title: "Marketing & Client",
      description:
        "By showcasing our expertise through thought leadership, personalized outreach, and strong client relationships, we attract and retain businesses seeking reliable, long-term advisory and support services.",
      servicesList: [
        "B2B digital campaigns",
        "Hosting webinars",
        "Partnerships networks",
        "Participation",
        "Affiliate & referral programs",
      ],
      image: "./assets/images/service6.webp",
      color: "bg-gradient-to-r from-pink-400 to-pink-600", // Pink gradient
    },
    "Revenue Forecast": {
      title: "Revenue Forecast",
      description:
        "In the first two years, Katella Venture Capital LLC projects steady growth driven by diversified service lines. Revenue is expected to reach approximately $250,000 in Year 1 through advisory fees, tax services, and real estate consulting",
      servicesList: [
        "VC Investment Returns",
        "Tax & Compliance",
        "Real Estate Projects",
        "Construction Modeling",
        "Zero Reporting",
        "Payroll Services",
      ],
      image: "./assets/images/service7.jpg",
      color: "bg-gradient-to-r from-indigo-400 to-indigo-600", // Indigo gradient
    },
    "Legal & Compliance": {
      title: "Legal & Compliance",
      description:
        "We ensure that our operations and client services adhere to federal, state, and industry-specific guidelines, including IRS regulations and corporate governance standards.",
      servicesList: [
        "Registered with the Texas Secretary of State",
        "SEC compliance",
        "Licensed CPAs",
        "Partnership agreements",
        "Data protection",
      ],
      image: "./assets/images/service8.jpg",
      color: "bg-gradient-to-r from-red-400 to-red-600", // Red gradient
    },
  };

  const currentService = services[selectedService];

  return (
    <div className="container px-6 py-12 mx-auto">
      <Fade bottom triggerOnce>
        <h1 className="text-5xl font-bold text-center text-theme-blue">
          Our Services
        </h1>
        <p className="pb-6 mb-12 text-lg font-light text-center text-gray-400 sm:mb-5 xl:mb-0">
          Our Services That You Need Most
        </p>
      </Fade>
      <div className="grid grid-cols-1 gap-4 mb-6 md:grid-cols-4">
        {Object.keys(services).map((service) => (
          <button
            key={service}
            type="button"
            onClick={() => setSelectedService(service)}
            className={`p-4 rounded-lg border border-gray-200 text-black shadow-md transition-transform transform hover:scale-105 ${
              selectedService === service
                ? `${services[service].color} scale-105`
                : "bg-gray-100 text-gray-700 hover:bg-gray-200"
            }`}
          >
            <h3 className="text-lg font-semibold">{service}</h3>
          </button>
        ))}
      </div>
      <div className="flex flex-col gap-6 md:flex-row">
        <div className="md:w-2/3">
          <h2 className="mb-4 text-2xl font-bold text-gray-800">
            {currentService.title}
          </h2>
          <p className="mb-4 text-gray-600">{currentService.description}</p>
          <ul className="grid grid-cols-2 gap-2 text-gray-600">
            {currentService.servicesList.map((item) => (
              <li key={item} className="flex items-start space-x-2">
                <svg
                  className="w-5 h-5 text-blue-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                <span>{item}</span>
              </li>
            ))}
          </ul>
          <a
            href="/"
            className="inline-block px-4 py-2 mt-4 text-white transition bg-gray-800 rounded hover:bg-gray-700"
          >
            LEARN MORE
          </a>
        </div>
        <div className="md:w-1/2">
          <img
            src={currentService.image}
            alt={currentService.title}
            className="object-cover w-full h-64 rounded-lg shadow-md"
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceSection;
